namespace JupitersChoice {
    export class CheckSpinnerCmd {

        @inject('AutoplayManager') _autoplayManager: Sapphire.AutoplayManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _server: Sapphire.GameServer;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;

        execute(): void {
            const response: any = this._server.logicResponse;

            // if feature unlocked, stop autoplay
            if (response.feature) {
                this._eventManager.publish('StopAutoplayButton:Press')
                this._eventManager.publish('onHasSpinner')
            } else {
                this._eventManager.publish('onHasNoSpinner')
            }
        }
    }
}